import { render, staticRenderFns } from "./propertyDetail.vue?vue&type=template&id=e5b4da1c&"
import script from "./propertyDetail.vue?vue&type=script&lang=js&"
export * from "./propertyDetail.vue?vue&type=script&lang=js&"
import style0 from "./propertyDetail.vue?vue&type=style&index=0&id=e5b4da1c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports